module.exports = __webpack_public_path__ + "static/media/instagram.ad27e94b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/instagram.svg
// module id = 313
// module chunks = 0